import axios from "axios";
import { toast } from "react-toastify";
import { basenameURL } from "services/utiles";

const instance = axios.create({
  baseURL: basenameURL,
  // baseURL: 'https://affirmate.life/affirmation_backend/api/user/',
});

instance.interceptors.request.use((request) => {
  // console.log('request', request);
  const token = sessionStorage.getItem("token");

  console.log("token>>>>>", token);

  request.headers.Authorization = `Bearer ${token}`;
  // request.headers.Authorization = `Bearer ${token}`
  return request;
});

instance.interceptors.response.use(
  (results) => {
    if (results?.data?.status === 401) {
      // sessionStorage.clear();
      window.location.href = "/zenfulnote-admin/login";
    } else if (results?.data?.status === 400) {
      toast.error(results?.data?.message);
    } else {
      return results.data;
    }
  },
  (error) => {
    console.log("err", error);
    // if (error.response.status === 401) {
    //     sessionStorage.clear();
    //     window.location.href = "/zenfulnote-admin/login";
    // }

    return Promise.reject(error);
  }
);

export default instance;
